import React from "react";
import { Link } from "react-router-dom";
import { Mail, Linkedin } from "lucide-react";

const columns = [
  {
    title: "Products",
    links: [
      { label: "Form OCR", to: "/form-ocr" },
      { label: "CMS 1500 OCR", to: "/cms-1500-ocr" },
      { label: "CMS 1450 OCR", to: "/cms-1450-ocr" },
      { label: "ADA J430D OCR", to: "/ada-j430d-ocr" },
      { label: "Enrollment Form OCR", to: "/enrollment-form-ocr" },
      { label: "Paper to EDI", to: "/paper-to-edi-service" },
      { label: "Paper to 835", to: "/paper-to-835" },
    ],
  },
  {
    title: "Company",
    links: [
      { label: "Enterprise", to: "/enterprise" },
      { label: "About Us", to: "/about-us" },
      { label: "Demo", to: "/demo/hcfa-cms-1500" },
    ],
  },
  {
    title: "Tools",
    links: [
      { label: "All Tools", to: "/tools" },
      { label: "NPI Validator", to: "/tools/npi-validator" },
      { label: "Fake NPI Generator", to: "/tools/fake-npi-generator" },
      { label: "Fake Patient Generator", to: "/tools/fake-patient-generator" },
      { label: "Synthetic 837 Generator", to: "/tools/payer-specific-synthetic-837" },
      { label: "NPI Lookup by Name", to: "/tools/npi-lookup-by-name" },
    ],
  },
  {
    title: "Resources",
    links: [
      { label: "CMS-1500 Claim Form boxes list", to: "/resources/cms-1500-claim-form-boxes-list" },
    ],
  },
  {
    title: "Contact",
    links: [
      { label: "Contact Sales", to: "/contact-sales" },
      { label: "Contact Us", to: "/contact-us" },
    ],
  },
  {
    title: "Legal",
    links: [
      { label: "Privacy Policy", to: "/privacy-policy" },
      { label: "T & C", to: "/tnc" },
      { label: "Refund", to: "/refund" },
    ],
  },
];

export const Footer = () => {
  return (
    <footer data-testid="site-footer" className="relative overflow-hidden bg-slate-950 text-slate-300">
      <div className="absolute inset-0 bg-grid-dark opacity-40" aria-hidden="true" />
      <div className="relative mx-auto max-w-7xl px-5 sm:px-8">
        <div className="grid grid-cols-1 gap-12 py-16 md:grid-cols-2 lg:grid-cols-8">
          <div className="lg:col-span-2">
            <img src="/logo-white.png" alt="Hewto.ai" className="h-8 w-auto" />
            <p className="mt-5 max-w-sm text-sm leading-relaxed text-slate-400">
              Intelligent document processing purpose-built for US healthcare. Turn HCFA, UB-04,
              and dental claims into clean, validated data in seconds.
            </p>
          </div>

          {columns.map((col) => (
            <div key={col.title}>
              <h4 className="text-sm font-semibold uppercase tracking-wider text-white">{col.title}</h4>
              <ul className="mt-4 space-y-3">
                {col.links.map((link) => (
                  <li key={link.label}>
                    <Link
                      to={link.to}
                      data-testid={`footer-link-${link.label.toLowerCase().replace(/[^a-z0-9]+/g, "-")}`}
                      className="text-sm text-slate-400 transition-colors hover:text-brand-200"
                    >
                      {link.label}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        <div className="flex flex-col items-center justify-between gap-4 border-t border-white/10 py-8 sm:flex-row">
          <p className="text-xs text-slate-500">
            © {new Date().getFullYear()} Hewto.ai. All rights reserved.
          </p>
          <div className="flex items-center gap-4">
            <a href="mailto:contactsales@hewto.ai" data-testid="footer-email" className="text-slate-400 transition-colors hover:text-brand-200">
              <Mail className="h-4 w-4" />
            </a>
            <a href="https://linkedin.com/company/hewto-ai" target="_blank" rel="noopener noreferrer" data-testid="footer-linkedin" className="text-slate-400 transition-colors hover:text-brand-200">
              <Linkedin className="h-4 w-4" />
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
